import { render, staticRenderFns } from "./InvitationExpiredMessage.vue?vue&type=template&id=6e0936b8"
import script from "./InvitationExpiredMessage.vue?vue&type=script&lang=js"
export * from "./InvitationExpiredMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports